export const COOKIE_NAME = {
  ACCESS_TOKEN: 'ARTIST_CENTER_ACCESS_TOKEN',
  REFERRAL_CODE: 'REFERRAL_CODE',
} as const
